module.exports = __webpack_public_path__ + "static/media/module.feb972ab.svg";